module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "agency"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('div', {
    staticClass: "agency-main"
  }, [_c('div', {
    staticStyle: {
      "padding": "20px",
      "background": "#fff",
      "border-bottom": "1px solid #ebecf5"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("一、是否满足下列条件")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "12px",
      "padding": "10px 0"
    }
  }, [_vm._v("\n          （1）金融资产不低于500万元人民币，或者最近3年个人年均收入不低于50万元人民币；\n          （2）具有2年以上证券、基金、期货、黄金、外汇等投资经历，或 者具有2年以上金融产品设计、投资、风险管理及相关工作经 历的自然人投资者，或者属于《证券提货投资者适当性管理 办法》第八条第(一)款所规定的专业投资者的高级管理人 员、获得职业资格认证的从事金融相关业务的注册会计师和 律师。\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('checker', {
    attrs: {
      "disabled": "",
      "default-item-class": "check-item",
      "selected-item-class": "check-item-selected"
    },
    model: {
      value: (_vm.data.userInvestmentExperience.checked),
      callback: function($$v) {
        _vm.$set(_vm.data.userInvestmentExperience, "checked", $$v)
      },
      expression: "data.userInvestmentExperience.checked"
    }
  }, [_c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0 || _vm.invenstemType !== 'SPECIFIC_PERSONAL_PRACTITIONERS',
      "value": "是"
    }
  }, [_c('my-check-style', [_vm._v("是")])], 1), _vm._v(" "), _c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0 || _vm.invenstemType !== 'SPECIFIC_PERSONAL_PRACTITIONERS',
      "value": "否"
    }
  }, [_c('my-check-style', [_vm._v("否")])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "20px",
      "background": "#fff",
      "border-bottom": "1px solid #ebecf5"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("二、私募基金或者资产管理计划投资者，最近20个交易日金融资产均不得低于人民币300万元，或者最近三年个人年均收入不 低于人民币50万元")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "check-item",
      "selected-item-class": "check-item-selected"
    },
    model: {
      value: (_vm.data.userAssetsScale.checked),
      callback: function($$v) {
        _vm.$set(_vm.data.userAssetsScale, "checked", $$v)
      },
      expression: "data.userAssetsScale.checked"
    }
  }, [_c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "是"
    }
  }, [_c('my-check-style', [_vm._v("是")])], 1), _vm._v(" "), _c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "否"
    }
  }, [_c('my-check-style', [_vm._v("否")])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "20px",
      "background": "#fff",
      "border-bottom": "1px solid #ebecf5"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("三、是否存在实际控制关系？")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "check-item",
      "selected-item-class": "check-item-selected"
    },
    model: {
      value: (_vm.data.isControllingShareholder.checked),
      callback: function($$v) {
        _vm.$set(_vm.data.isControllingShareholder, "checked", $$v)
      },
      expression: "data.isControllingShareholder.checked"
    }
  }, [_c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "是"
    }
  }, [_c('my-check-style', [_vm._v("是")])], 1), _vm._v(" "), _c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "否"
    }
  }, [_c('my-check-style', [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data.isControllingShareholder.checked === '是'),
      expression: "data.isControllingShareholder.checked === '是'"
    }]
  }, [_c('group', [_c('x-textarea', {
    attrs: {
      "placeholder": "请说明",
      "readonly": _vm.type === 0,
      "rows": 1,
      "autosize": ""
    },
    model: {
      value: (_vm.data.isControllingShareholder.description),
      callback: function($$v) {
        _vm.$set(_vm.data.isControllingShareholder, "description", $$v)
      },
      expression: "data.isControllingShareholder.description"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "20px",
      "background": "#fff",
      "border-bottom": "1px solid #ebecf5"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("四、交易实际受益人？")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "check-item",
      "selected-item-class": "check-item-selected"
    },
    model: {
      value: (_vm.data.transactionActualBeneficiary.checked),
      callback: function($$v) {
        _vm.$set(_vm.data.transactionActualBeneficiary, "checked", $$v)
      },
      expression: "data.transactionActualBeneficiary.checked"
    }
  }, [_c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "本人"
    }
  }, [_c('my-check-style', [_vm._v("本人")])], 1), _vm._v(" "), _c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "他人"
    }
  }, [_c('my-check-style', [_vm._v("他人")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data.transactionActualBeneficiary.checked === '他人'),
      expression: "data.transactionActualBeneficiary.checked === '他人'"
    }]
  }, [_c('group', [_c('x-textarea', {
    attrs: {
      "placeholder": "请说明",
      "readonly": _vm.type === 0,
      "rows": 1,
      "autosize": ""
    },
    model: {
      value: (_vm.data.transactionActualBeneficiary.description),
      callback: function($$v) {
        _vm.$set(_vm.data.transactionActualBeneficiary, "description", $$v)
      },
      expression: "data.transactionActualBeneficiary.description"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "20px",
      "background": "#fff",
      "border-bottom": "1px solid #ebecf5"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("五、是否有不良诚信记录？")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "check-item",
      "selected-item-class": "check-item-selected"
    },
    model: {
      value: (_vm.data.isBadFaith.checked),
      callback: function($$v) {
        _vm.$set(_vm.data.isBadFaith, "checked", $$v)
      },
      expression: "data.isBadFaith.checked"
    }
  }, [_c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "是"
    }
  }, [_c('my-check-style', [_vm._v("是")])], 1), _vm._v(" "), _c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "否"
    }
  }, [_c('my-check-style', [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data.isBadFaith.checked === '是'),
      expression: "data.isBadFaith.checked === '是'"
    }]
  }, [_c('group', [_c('x-textarea', {
    attrs: {
      "placeholder": "请说明",
      "readonly": _vm.type === 0,
      "rows": 1,
      "autosize": ""
    },
    model: {
      value: (_vm.data.isBadFaith.description),
      callback: function($$v) {
        _vm.$set(_vm.data.isBadFaith, "description", $$v)
      },
      expression: "data.isBadFaith.description"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('submit-button', {
    on: {
      "click": _vm.$_personal_submit
    }
  }, [_vm._v("提 交")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29c00764"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InvestorInfo/Personal/Question.vue
// module id = 1030
// module chunks = 1